import React, { useState, useEffect, useRef } from 'react'
import { Container } from 'react-awesome-styled-grid'
import ScrollLock, { TouchScrollable } from 'react-scrolllock'

import { useWindowSize } from '@react-hook/window-size'
import { Breadcrumb } from 'gatsby-plugin-breadcrumb'
import PropTypes from 'prop-types'

import { dataLayerEvent } from '../../../utils/google'
import Icon from '../../helpers/Icon'
import Link from '../../helpers/Link'
import ToggleMenu from '../../helpers/ToggleMenu'
import DropdownItem from './DropdownItem'
import { menuLinks } from './menu'
import * as S from './styled'

const Header = ({ submenu, location, crumbs, crumbLabel }) => {
  const [width] = useWindowSize()
  const [isDropdownOpen, setDropdownOpen] = useState(false)
  const [isMenuOpen, setMenuOpen] = useState(false)
  const [isSubMenuOpen, setSubMenuOpen] = useState(false)
  const [isSticky, setSticky] = useState(false)

  const bar = useRef(null)
  const subBar = useRef(null)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    if (width > 768) {
      setMenuOpen(false)
      setSubMenuOpen(false)
    }

    return () => {
      window.removeEventListener('scroll', () => handleScroll)
    }
  }, [width])

  const handleScroll = () => {
    if (bar && bar.current && bar.current.getBoundingClientRect()) {
      setSticky(bar.current.getBoundingClientRect().top < -60)
    }
  }

  return (
    <>
      <ScrollLock isActive={isMenuOpen} />
      <S.HeaderWrapper>
        <S.HeaderBar
          ref={bar}
          className={`menu-${isMenuOpen ? 'opened' : 'closed'}`}
        >
          <Container>
            <S.HeaderContent>
              <S.HeaderBrand />

              <S.HeaderNav>
                <TouchScrollable>
                  <S.HeaderMenu>
                    {menuLinks.map(({ label, to, dropdown }, key) => {
                      if (dropdown) {
                        return (
                          <DropdownItem
                            key={key}
                            i={key}
                            label={label}
                            to={to}
                            dropdown={dropdown}
                            open={isDropdownOpen}
                            setOpen={setDropdownOpen}
                          />
                        )
                      } else {
                        return (
                          <S.HeaderNavItem key={key}>
                            <S.HeaderNavLink href={to} title={label}>
                              {label}
                            </S.HeaderNavLink>
                          </S.HeaderNavItem>
                        )
                      }
                    })}
                  </S.HeaderMenu>
                </TouchScrollable>
                <S.HeaderUtil>
                  <S.HeaderLogin
                    as="a"
                    className="has-icon-left"
                    color="neutral900"
                    onClick={() => dataLayerEvent('cliqueAcessarSistema')}
                    href="https://superlogica.net/clients"
                    title="Acessar sistema"
                    size="small"
                  >
                    <Icon
                      name="single-neutral-circle"
                      color="blue500"
                      size={20}
                    />
                    Acessar sistema
                  </S.HeaderLogin>
                </S.HeaderUtil>
              </S.HeaderNav>

              <ToggleMenu isOpen={isMenuOpen} setOpen={setMenuOpen} />
            </S.HeaderContent>
          </Container>
        </S.HeaderBar>

        {submenu && (
          <S.HeaderSubBar
            ref={subBar}
            className={`submenu-${
              isSubMenuOpen ? 'expanded' : 'closed'
            } sticky-${isSticky ? 'enabled' : 'disabled'}`}
          >
            <Container>
              <S.HeaderSubBarContent>
                <Breadcrumb
                  crumbs={crumbs.map(({ pathname, ...rest }, i) => {
                    return {
                      pathname: pathname.replace(/\/?$/, '/'),
                      ...rest
                    }
                  })}
                  crumbLabel={crumbLabel}
                  crumbSeparator=">"
                />
                <S.HeaderNav>
                  <S.HeaderMenu>
                    {submenu.map(({ label, to }, i) => {
                      return (
                        <S.HeaderNavItem key={i}>
                          <S.HeaderNavLink
                            to={to}
                            title={label}
                            activeClassName="active"
                            as={Link}
                          >
                            {label}
                          </S.HeaderNavLink>
                        </S.HeaderNavItem>
                      )
                    })}
                  </S.HeaderMenu>
                </S.HeaderNav>
                <S.HeaderSubBarToggle
                  onClick={() => setSubMenuOpen(!isSubMenuOpen)}
                >
                  <S.HeaderSubBarArrow
                    name={`arrow-down-1`}
                    size={12}
                    color="neutral900"
                  />
                </S.HeaderSubBarToggle>
              </S.HeaderSubBarContent>
            </Container>
          </S.HeaderSubBar>
        )}
      </S.HeaderWrapper>
    </>
  )
}

Header.propTypes = {
  submenu: PropTypes.array,
  location: PropTypes.object,
  crumbLabel: PropTypes.string,
  crumbs: PropTypes.array
}

export default Header
